import { render, staticRenderFns } from "./ttshop_integral.vue?vue&type=template&id=a5aaad8c&scoped=true&"
import script from "./ttshop_integral.vue?vue&type=script&lang=js&"
export * from "./ttshop_integral.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_integral.vue?vue&type=style&index=0&id=a5aaad8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5aaad8c",
  null
  
)

export default component.exports